import { ImgHTMLAttributes } from "react";
import styled from "styled-components";

export const DEFAULT_SIZE = 64;

export const NafLogo = styled(
  ({
    size = DEFAULT_SIZE,
    ...props
  }: { size?: number } & Omit<
    ImgHTMLAttributes<HTMLImageElement>,
    "width" | "height" | "src" | "alt"
  >) => (
    <img
      width={size}
      height={size}
      {...props}
      src="/graphics/logos/naf-logo_128x128.png"
      alt="NAF"
    />
  )
)``;
